<template>
  <div class="box">
    <!-- 搜索 -->
    <div class="search">
      <div class="search-left">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="书单名称：">
            <el-input
              v-model="formInline.title"
              placeholder="书单名称"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="search-right">
        <el-button type="primary" @click="search">查询</el-button>
      </div>
    </div>
    <!-- 标题 -->
    <div class="title">
      <div style="display: flex;justify-content: center; align-items: center;">
        <div>书单列表</div>
        <el-button
          class="button"
          type="primary"
          style="margin-left: 10px;"
          @click="editSort()"
          >排序管理</el-button
        >
        <el-button
          v-show="isSortShow"
          type="primary"
          style="margin-right: 10px;"
          class="button"
          @click="saveSortData()"
          >保存排序</el-button
        >
      </div>
      <el-button type="primary" @click="add">新增</el-button>
    </div>
    <!-- 列表 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      v-loading="loading"
      v-show="isSortShow"
      ref="multipleTable"
      row-key="id"
      border
    >
      <el-table-column prop="id" label="ID" align="center"> </el-table-column>
      <el-table-column prop="title" label="标题" align="center">
      </el-table-column>
      <el-table-column prop="summary" label="简介" align="center">
      </el-table-column>
      <el-table-column label="书单图片" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 96px; height: 120px"
            :src="scope.row.image_url"
            :preview-src-list="[scope.row.image_url]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="是否显示" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.is_show == 1">显示</span>
          <span v-else>不显示</span>
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">域外库</span>
          <span v-else-if="scope.row.type == 2">基础库</span>
          <span v-else>孤本库</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" @click="del(scope.row, 1)">删除</el-button>
          <el-button type="text" @click="itemList(scope.row)"
            >关联列表</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="tableData" style="width: 100%" v-loading="loading" 
      v-show="!isSortShow">
      <el-table-column prop="id" label="ID" align="center"> </el-table-column>
      <el-table-column prop="title" label="标题" align="center">
      </el-table-column>
      <el-table-column prop="summary" label="简介" align="center">
      </el-table-column>
      <el-table-column label="书单图片" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 96px; height: 120px"
            :src="scope.row.image_url"
            :preview-src-list="[scope.row.image_url]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="是否显示" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.is_show == 1">显示</span>
          <span v-else>不显示</span>
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">域外库</span>
          <span v-else-if="scope.row.type == 2">基础库</span>
          <span v-else>孤本库</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" @click="del(scope.row, 1)">删除</el-button>
          <el-button type="text" @click="itemList(scope.row)"
            >关联列表</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="totalPages > 1">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="page_size"
        :total="pageTotal"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 编辑 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form ref="ruleForm" :model="form" label-width="120px">
        <el-form-item label="标题：" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="简介：" prop="summary">
          <el-input type="textarea" v-model="form.summary"></el-input>
        </el-form-item>
        <el-form-item label="书单图片：" prop="image_url">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="form.image_url"
              :src="form.image_url"
              class="avatar"
              alt="加载失败"
            />
            <em
              v-show="!form.image_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否显示：" prop="duration">
          <el-select v-model="form.is_show" class="handle-select mr10">
            <el-option
              v-for="(child, index) in is_show"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属库别：" prop="type">
          <el-select v-model="form.type" class="handle-select mr10">
            <el-option
              v-for="(child, index) in type"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >保 存</el-button
        >
        <el-button type="primary" @click="editVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :visible.sync="editListVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form ref="ruleForm" :model="formList" label-width="120px">
        <el-form-item label="书单名称：">
          <el-input disabled v-model="formList.title"></el-input>
        </el-form-item>
        <el-form-item label="古籍ID：">
          <el-input type="text" v-model="formList.books_id"></el-input>
        </el-form-item>
        <el-form-item label="所属库别(根据古籍ID选择)：" label-width="190px">
          <el-select v-model="formList.type" class="handle-select mr10">
            <el-option
              v-for="(child, index) in type"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="submit">保 存</el-button>
        <el-button type="primary" @click="editListVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 删除 -->
    <el-dialog :visible.sync="isItemListDialog" width="60%" border>
      <!-- 标题 -->
      <div class="title">
        <div>关联列表</div>
        <el-button class="button" type="primary" @click="addList"
          >新增</el-button
        >
      </div>
      <el-table
        :data="tableList"
        style="width: 100%; margin-bottom: 20px"
        v-loading="loading"
        border
      >
        <el-table-column
          prop="books_group_id"
          align="center"
          label="书单ID"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="books_id"
          align="center"
          label="古籍ID"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="info.title"
          align="center"
          label="标题"
          width="150"
        >
        </el-table-column>
        <el-table-column label="封面" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 96px; height: 120px"
              :src="scope.row.info.cover"
              :preview-src-list="[scope.row.info.cover]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          align="center"
          label="创建时间"
          width="150"
        >
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="editList(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="del(scope.row, 2)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="list_totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="list_currentPage"
          :page-size="list_page_size"
          :total="list_pageTotal"
          @current-change="handlePageChange1"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from "../../../api/zkApiConfig";
import http2 from "../../../api/uploadApiConfig";
import Sortable from "sortablejs";
import md5 from "js-md5";
export default {
  data() {
    return {
      dataArr: [],
      ids: [],
      isSortShow: false,
      id: "",
      // ----------------搜索----------------
      formInline: {
        ku_type: "1",
        category_id: "",
      },
      //   库别
      ku_type: [
        {
          value: "1",
          label: "基础库",
        },
        {
          value: "2",
          label: "域外库",
        },
        {
          value: "3",
          label: "孤本库",
        },
      ],
      //   类别
      categoryData: [],
      options: [],
      categoryProps: {
        label: "name", // 字段必须统一
        value: "id", // 字段必须统一
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          http
            .get("/admin/admin_books/zk_categories", {
              params: { pid: node.data.id },
            })
            .then((res) => {
              setTimeout(() => {
                console.log(res);
                const nodes = res.data.data.map((item) => ({
                  id: item.id,
                  name: item.name,
                  leaf: level >= 2,
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }, 1000);
            });
        },
      },
      //   所属库别
      type: [
        {
          value: 1,
          label: "域外库",
        },
        {
          value: 2,
          label: "基础库",
        },
        {
          value: 3,
          label: "孤本库",
        },
      ],

      // ----------------列表----------------
      tableData: [],
      tableList: [],

      // ----------------详情----------------
      form: {
        is_show: 1,
      },
      formList: {},
      editVisible: false,
      editListVisible: false,
      isItemListDialog: false,
      is_add: true,
      editTitle: "书单编辑页",
      //   是否推荐
      is_show: [
        { label: "显示", value: 1 },
        { label: "不显示", value: 0 },
      ],
      //   分页
      currentPage: 1,
      totalPages: 1,
      page_size: 999,
      pageTotal: 10,
      page_index: 10,
      //   关联列表分页
      list_currentPage: 1,
      list_totalPages: 1,
      list_page_size: 10,
      list_pageTotal: 10,
      list_page_index: 10,
      //  ----------------dialog----------------
      loading: false,
      //   上传图片
      uploading: false,
      imageUrl: "",
      itemList_id: "",
    };
  },
  mounted() {
    this.getDefault();
  },
  methods: {
    // 排序管理
    editSort() {
      this.isSortShow = !this.isSortShow;
    },
    // 保存排序
    saveSortData() {
      this.ids = [];
      for (let i = 0; i < this.dataArr.length; i++) {
        this.ids.push(this.dataArr[i].id);
      }
      let params = {
        ids: this.ids.toString(),
      };
      http.put("/admin/books_groups/sort", params).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("保存成功");
          this.isSortShow = false;
          this.getDefault();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 拖拽
    initSortTable() {
      // 获取 el-table
      const tableTag = this.$refs["multipleTable"].$el;
      // 获取 tbody 节点
      const elTbody = tableTag.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      // 拖拽排序
      this.sortable = Sortable.create(elTbody, {
        onEnd: (evt) => {
          const tempIndex = this.dataArr.splice(evt.oldIndex, 1)[0];
          this.dataArr.splice(evt.newIndex, 0, tempIndex);
          console.log(this.dataArr, "dataArr");
        },
      });
    },
    // 关联列表
    itemList(row) {
      if (row != undefined && row.id) {
        this.itemList_id = row.id;
        this.itemList_title = row.title;
      }
      let params = {
        books_group_id: this.itemList_id,
        page: this.list_currentPage,
        page_size: this.list_page_size,
      };
      http
        .get("/admin/books_groups/item_list", { params: params })
        .then((res) => {
          if (res.data.status_code == 200) {
            this.tableList = res.data.data.data;
            this.list_currentPage = Number(res.data.data.current_page);
            this.list_totalPages = res.data.data.last_page;
            this.list_pageTotal = this.list_totalPages * this.list_page_size;
            this.isItemListDialog = true;
          }
        });
    },
    // 关联新增
    addList() {
      this.editListVisible = true;
      this.is_add = true;
      this.formList = {};
      this.formList.books_group_id = this.itemList_id;
      this.formList.title = this.itemList_title;
    },
    // 关联编辑
    editList(row) {
      this.is_add = false;
      this.formList = row;
      this.formList.title = this.itemList_title;
      this.editListVisible = true;
    },
    submit() {
      if (this.is_add == true) {
        let params = this.formList;
        http.post("/admin/books_groups/item/add", params).then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("新增成功");
            this.itemList();
            this.editListVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        let params = this.formList;
        http
          .put("/admin/books_groups/item/edit/" + this.formList.id, params)
          .then((res) => {
            if (res.data.status_code == 200) {
              this.$message.success("编辑成功");
              this.itemList();
              this.editListVisible = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getDefault();
    },
    // 分页导航
    handlePageChange1(val) {
      this.list_currentPage = val;
      this.itemList();
    },
    getDefault() {
      let params = {
        page: this.currentPage,
        page_size: this.page_size,
        title: this.formInline.title,
      };
      http.get("/admin/books_groups/list", { params: params }).then((res) => {
        if (res.data.status_code == 200) {
          this.tableData = res.data.data.data;
          this.dataArr = res.data.data.data;
          this.$nextTick(() => {
            this.initSortTable();
          });
          this.currentPage = Number(res.data.data.current_page);
          this.totalPages = res.data.data.last_page;
          this.pageTotal = this.totalPages * this.page_size;
          this.loading = false;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.getDefault();
    },
    add() {
      this.is_add = true;
      this.editVisible = true;
      this.form = {};
    },
    edit(row) {
      console.log(row, "row");
      this.is_add = false;
      this.editVisible = true;
      this.form = row;
    },
    saveEdit() {
      if (this.is_add == true) {
        let params = this.form;
        params.image = this.imageUrl;
        http.post("/admin/books_groups/add", params).then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("新增成功");
            this.getDefault();
            this.editVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        let params = this.form;
        if (params.image_url) {
          delete params.image_url;
        }
        if (this.imageUrl != "") {
          params.image = this.imageUrl;
        }
        http
          .put("/admin/books_groups/edit/" + this.form.id, this.form)
          .then((res) => {
            if (res.data.status_code == 200) {
              this.$message.success("修改成功");
              this.getDefault();
              this.editVisible = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    del(row, type) {
      let that = this;
      if (type == 1) {
        // 二次确认删除
        that
          .$confirm("确定要删除吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http.delete("/admin/books_groups/delete/" + row.id).then((res) => {
              if (res.data.status_code == 200) {
                that.getDefault();
                that.$message.success("删除成功");
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      } else {
        that
          .$confirm("确定要删除吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http.delete("/admin/books_groups/item/" + row.id).then((res) => {
              if (res.data.status_code == 200) {
                that.itemList();
                that.$message.success("删除成功");
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 图片上传
    beforeAvatarUpload(file) {
      console.log(file, "file");
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        let fileNames = file.name.split("/")[0];
        var time = new Date().getTime();
        var filename = md5(time + fileNames) + "." + imgType;
        ossData.append("work_path", "icon/books_group");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        http2.post("upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.imageUrl = "icon/books_group/" + filename;
            that.form.image_url = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style scoped>
.box {
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
}
.search {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.search-left {
  width: 70%;
  display: flex;
  flex-wrap: wrap;
}
.search-left-bottom {
  width: 100%;
}
.title {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button {
  float: right;
}
.nBuild-title {
  padding: 20px;
  color: #169bd5;
}
.border {
  width: 100%;
  height: 1px;
  margin: 10px 0;
  background-image: linear-gradient(
    to right,
    rgb(121, 121, 121) 0%,
    rgb(121, 121, 121) 50%,
    transparent 50%
  );
  background-size: 20px 2px;
  background-repeat: repeat-x;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 180px;
  height: 180px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border: 1px solid #000;
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
</style>
